import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styled from 'styled-components';

import theme from '@theme/FolxTheme';

export default styled(ToastContainer)`
	// The full list of overrideable classes can be found at
	// https://fkhadra.github.io/react-toastify/how-to-style#override-existing-css-classes

	.Toastify__toast-theme--colored.Toastify__toast--info {
		background-color: ${theme.colors.lilacMedium};
		color: ${theme.colors.white};

		svg {
			path {
				fill: ${theme.colors.white};
			}
		}
	}
`;
